/**
 * The default content-type header configuration for all HTTP methods.
 * @type {Object}
 */
export const CONTENT_TYPE_HEADER = { 'Content-Type': 'application/json; charset=utf-8' };
